import { DetailGroupPack } from "./detail-group-pack";

export class MenuItem
{
    public OrderID:string = '';
    public ComboID:string = '';
    public ID:string = '';
    public UniversalID:string = '';
    public Tags:string[] = Array<string>();
    public Show:boolean = true;
    public ShowDay:boolean[] = new Array(true, true, true, true, true, true, true);
    public Display:number = 0;

    public Icon:string = 'assets/img/placeholder.png';
    public Picture:string = 'assets/img/placeholder.png';
    public Name:string = '';
    public Description:string = '';

    public Comentary:string = '';

    public ItemCount:number = 1;
    public OriginalPrice:number = 0.0;
    public DefaultPrice:number = 0.0;
    public ComboPrice:number = 0.0;

    public PrintName:string = '';

    public Number:number = 0;
    public Timestamp:number = 0;
    public Removed:boolean = false;
    public OutOfStock:boolean = false;

    public DetailCount:number = 0;

    public DetailGroups:Array<MenuItemDetailGroup> = new Array<MenuItemDetailGroup>();

    public ProductCount:number = 0;

    //public List<ProductRequestModel> Recipe { get; set; }

    public get DefaultPriceString()
    {
        return this.DefaultPrice.toLocaleString('pt-BR', { style: 'currency',  currency : 'BRL'});
    }

    setData(data:any)
    {
        if (typeof(data.DetailGroups) !== 'undefined' && data.DetailGroups !== null) 
        {
            this.DetailGroups = new Array<MenuItemDetailGroup>();

            for (const key in data.DetailGroups) 
            {
                if (Object.prototype.hasOwnProperty.call(data.DetailGroups, key)) 
                {
                    const element = data.DetailGroups[key];
                    
                    let detailGroup = new MenuItemDetailGroup();

                    Object.assign(detailGroup, element);

                    detailGroup.setData(element);

                    this.DetailGroups.push(detailGroup);
                }
            }
        }
    }
}

export class MenuItemDetailGroup
{
    public ID:string = '';
    public Name:string = '';
    public Description:string = '';
    public Type:number = 0;
    public Priority:number = 0;
    public Locked:boolean = false;
    public LimitMacroSelection = false;
    public MacroID = '';
    public MacroMaxSelectionCount = 0;
    public MacroMinSelectionCount = 0;
    public LimitSelection = false;
    public MinSelectionCount = 0;
    public MaxSelectionCount = 0;
    public AlwaysShowList = false;

    public DetailPresetList:Array<DetailPreset> = new Array<DetailPreset>();

    public CurrentDetailIDList:Array<string> = new Array<string>();

    setData(data:any)
    {
        if (typeof(data.DetailPresetList) !== 'undefined' && data.DetailPresetList !== null) 
        {
            this.DetailPresetList = new Array<DetailPreset>();

            for (const key in data.DetailPresetList) 
            {
                if (Object.prototype.hasOwnProperty.call(data.DetailPresetList, key)) 
                {
                    const element = data.DetailPresetList[key];
                    
                    let detailPreset = new DetailPreset();

                    this.DetailPresetList.push(Object.assign(detailPreset, element));
                }
            }
        }
    }
}

export class DetailPreset
{
    public Priority:number = 0;
    public DetailUniversalID:string = '';
    public MaxCount:number = 1;
    public DefaultCount:number = 0;
    public Locked:boolean = false;
    public HasValue:boolean = true;
    public Display:number = 0;
}